import React from "react";
import {
  KeyboardAvoidingView,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
  StyleSheet,
} from "react-native";
import {globalFontStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import Width from "../../../assets/Width";
import {isMobile} from "../../../utils/commonMethods";
import CouponBlk from "./couponBlk";
import ManualCouponBlk from "./manualCouponBlk";

const CouponBottomSheet = ({couponList, onApplyclick, isError = false}) => {
  return (
    <KeyboardAvoidingView
      style={styles.container}
      behavior="height"
      keyboardVerticalOffset={20}
      enabled>
      <ScrollView
        style={styles.scrollView}
        keyboardShouldPersistTaps={"handled"}
        showsVerticalScrollIndicator={false}>
        <TouchableOpacity activeOpacity={1}>
          <View style={styles.contentContainer}>
            <Text style={[globalFontStyle.appFontHeading, styles.heading]}>
              Coupons for you
            </Text>
            <ManualCouponBlk 
              onPromoApply={onApplyclick} 
              isError={isError} 
              isBottomSheet={true} 
            />
            <View style={styles.divider}/>
            {couponList?.map(data => (
              <View style={styles.couponItem} key={data?.couponcode}>
                <CouponBlk couponItem={data} onApplyclick={onApplyclick} />
              </View>
            ))}
          </View>
        </TouchableOpacity>
      </ScrollView>
    </KeyboardAvoidingView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
  },
  scrollView: {
    maxHeight: Width.height * 0.7,
  },
  contentContainer: {
    padding: 16,
  },
  heading: {
    marginBottom: 16,
    textAlign: 'center',
  },
  divider: {
    height: 1,
    backgroundColor: Colors.borderColor,
    marginVertical: 16,
  },
  couponItem: {
    marginBottom: 12,
  }
});

export default CouponBottomSheet;
